import React, { Component } from 'react';
import { withStyles, MenuItem, ListItemText, ClickAwayListener, Grow, Paper, Popper, Checkbox } from '@material-ui/core';
import ActionButtons from '../../../../../common/components/UI/ActionButtons/ActionButtons';
import CustomToolTip from '../../../../../common/components/UI/ToolTip/ToolTip';
import { translate } from 'react-i18next';
import { tableToolbar } from '../../../../styles/workplanStyles';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faColumns, faWindowMaximize } from '@fortawesome/pro-regular-svg-icons';
import { cloneDeep } from 'lodash';
import { updateDataviewColumns, updateTableColumns, updateTotalsColumns } from '../../actions';
import clsx from 'clsx';

const styles = theme => (tableToolbar(theme));

class ColumnsManager extends Component {
    constructor(props) {
        super(props);
        const { totalsColumns } = this.props;

        this.state = {
            unsubmittedDataviewColumns: [],
            unsubmittedTotalsColumns: cloneDeep(totalsColumns),
            totalsButtonAnchor: null,
            dataviewButtonAnchor: null,
        }
    }

    componentDidUpdate() {
        const { dataviewColumns } = this.props;
        const { unsubmittedDataviewColumns } = this.state;

        if (!unsubmittedDataviewColumns.length && dataviewColumns.length) {
            this.setState({
                unsubmittedDataviewColumns: cloneDeep(dataviewColumns),
            });
        }
    }

    handleClose = () => {
        this.setState({ 
            totalsButtonAnchor: null,
            dataviewButtonAnchor: null,
        });
    }

    handleDataviewColumnsCheck = (e, index) => {
        const { unsubmittedDataviewColumns } = this.state;
        const newDataviewColumns = cloneDeep(unsubmittedDataviewColumns);

        newDataviewColumns[index].visible = !(newDataviewColumns[index].visible)
        this.setState({ unsubmittedDataviewColumns: newDataviewColumns });
        e.stopPropagation();
    }

    genDataviewMenuItems = () => {
        const { classes } = this.props;
        const { unsubmittedDataviewColumns } = this.state;

        const StyledMenuItem = withStyles((theme) => ({
        }))(MenuItem);

        return unsubmittedDataviewColumns.map((col, index) => {
            return <StyledMenuItem key={`dataview-column-menu-item-${col.label}-${index}`}>
                <ListItemText onClick={(e) => { this.handleDataviewColumnsCheck(e, index) }}>
                    <Checkbox
                        style={{ padding: 0 }}
                        size="small"
                        color="primary"
                        checked={col.visible}
                        className={classes.inputCheckbox}
                    />
                    <span style={{ paddingLeft: 10 }}>{col.label}</span>
                </ListItemText>
            </StyledMenuItem>
        })
    }

    handleTotalsColumnsCheck = (e, index) => {
        const { unsubmittedTotalsColumns } = this.state;
        const newTotalsColumns = cloneDeep(unsubmittedTotalsColumns);

        newTotalsColumns[index].visible = !(newTotalsColumns[index].visible)
        this.setState({ unsubmittedTotalsColumns: newTotalsColumns });
        e.stopPropagation();
    }

    genTotalsMenuItems = () => {
        const { classes, t } = this.props;
        const { unsubmittedTotalsColumns } = this.state;

        const StyledMenuItem = withStyles((theme) => ({
        }))(MenuItem);

        return unsubmittedTotalsColumns.map((col, index) => (<StyledMenuItem>
            <ListItemText 
                onClick={(e) => { !col.disabled && this.handleTotalsColumnsCheck(e, index) }}
                className={col.disabled && classes.disabledOption}
            >
                <Checkbox
                    style={{ padding: 0 }}
                    size="small"
                    color="primary"
                    checked={col.visible}
                    className={classes.inputCheckbox}
                    disabled={col.disabled}
                />
                <span style={{ paddingLeft: 10 }} >{t(`settings.dataVisibility.${col.key}`)}</span>
            </ListItemText>
        </StyledMenuItem>));
    }

    submitDataviewColumns = async () => {
        const { genColumns, updateDataviewColumns, selectedWorkPlan, checkedAll, updateTableColumns } = this.props;
        const { unsubmittedDataviewColumns } = this.state;

        await updateDataviewColumns({ dataviewColumns : unsubmittedDataviewColumns });
        updateTableColumns(genColumns(selectedWorkPlan, false, false, checkedAll));
        this.handleClose();
    }

    submitTotalsColumns = async () => {
        const { genColumns, updateTotalsColumns, selectedWorkPlan, checkedAll, updateTableColumns } = this.props;
        const { unsubmittedTotalsColumns } = this.state;

        await updateTotalsColumns({ totalsColumns : unsubmittedTotalsColumns });
        updateTableColumns(genColumns(selectedWorkPlan, false, false, checkedAll));
        this.handleClose();
    }

    render() {
        const { disableToolbar, classes, dataviewColumns, totalsColumns, t } = this.props;
        const { totalsButtonAnchor, dataviewButtonAnchor } = this.state;
        return (
            <React.Fragment>
                <CustomToolTip enterDelay={500} placement="right-start" leaveDelay={500} titletext={t('workPlanView.table.totalsColumns')}
                    jsx={
                        <span
                        disabled={classes.tableColumnButton}
                        className={clsx(classes.tableColumnButton, disableToolbar ? classes.disabledButton : '')}
                        onClick={(event) => { this.setState({ 
                            totalsButtonAnchor : totalsButtonAnchor ? null : event.currentTarget,
                            dataviewButtonAnchor : null,
                        })}}
                    >
                        <FontAwesomeIcon transform={{ rotate: 270 }} icon={faWindowMaximize} /> 
                    </span>
                    }
			    />
                <CustomToolTip enterDelay={500} placement="right-start" leaveDelay={500} titletext={t('workPlanView.table.dataviewColumns')}
                    jsx={
                        <span
                        disabled={classes.tableColumnButton}
                        className={clsx(classes.tableColumnButton, disableToolbar ? classes.disabledButton : '')}
                        onClick={(event) => { this.setState({ 
                            totalsButtonAnchor : null,
                            dataviewButtonAnchor : dataviewButtonAnchor ? null : event.currentTarget,
                        })}}
                    >
                        <FontAwesomeIcon className={classes.iconButton} color={disableToolbar ? '#bdbdbd' : '#0A54A2'} icon={faColumns} />
                    </span>
                    }
			    />
                <Popper
                    open={!!totalsButtonAnchor}
                    anchorEl={totalsButtonAnchor}
                    placement={'bottom-start'}
                    transition
                    className={classes.popoverEeOptions}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'left bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <div className={classes.menuActions}>
                                        <div style={{overflow: 'auto'}}>
                                            {this.genTotalsMenuItems()}
                                        </div>
                                        <ActionButtons
                                            cancel={() => {
                                                this.setState({ unsubmittedTotalsColumns: totalsColumns });
                                                this.handleClose();
                                            }}
                                            submit={this.submitTotalsColumns}
                                        />
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
                <Popper
                    open={!!dataviewButtonAnchor}
                    anchorEl={dataviewButtonAnchor}
                    placement={'bottom-start'}
                    transition
                    className={classes.popoverEeOptions}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'left bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <div className={classes.menuActions}>
                                        <div className={classes.menuOtherActions}>
                                            {this.genDataviewMenuItems()}
                                        </div>
                                        <ActionButtons
                                            cancel={() => {
                                                this.setState({ unsubmittedDataviewColumns: dataviewColumns });
                                                this.handleClose();
                                            }}
                                            submit={this.submitDataviewColumns}
                                        />
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        dataviewColumns: state.dataviewColumns,
        totalsColumns: state.totalsColumns,
        selectedWorkPlan: state.selectedWorkPlan,
        checkedAll: state.checkedAll
    }
}

const mapDispatchToProps = {
    updateDataviewColumns,
    updateTotalsColumns,
    updateTableColumns
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(ColumnsManager)));